"use strict";
/* eslint-disable prettier/prettier */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggIntervalHelpers = void 0;
/**********************************************************************
 * WARNING: This file is auto-generated. Do not edit directly.
 * This file is generated by the script located in value-type-definitions/scripts
 * and should not be modified manually.
 ***********************************************************************/
const AlmondBloom = __importStar(require("./by-domain/almond_bloom/almond_bloom"));
const AlmondHullSplit = __importStar(require("./by-domain/almond_hull_split/almond_hull_split"));
const Alternaria = __importStar(require("./by-domain/alternaria/alternaria"));
const BeeHours = __importStar(require("./by-domain/bee_hours/bee_hours"));
const CherryPowderyMildew = __importStar(require("./by-domain/cherry_powdery_mildew/cherry_powdery_mildew"));
const Chill = __importStar(require("./by-domain/chill/chill"));
const DegreeDaysCrop = __importStar(require("./by-domain/degree_days_crop/degree_days_crop"));
const DegreeDaysInsect = __importStar(require("./by-domain/degree_days_insect/degree_days_insect"));
const Evapotranspiration = __importStar(require("./by-domain/evapotranspiration/evapotranspiration"));
const FireBlight = __importStar(require("./by-domain/fire_blight/fire_blight"));
const FruitGrowth = __importStar(require("./by-domain/fruit_growth/fruit_growth"));
const GrapePowderyMildew = __importStar(require("./by-domain/grape_powdery_mildew/grape_powdery_mildew"));
const Irrigation = __importStar(require("./by-domain/irrigation/irrigation"));
const LeafWetness = __importStar(require("./by-domain/leaf_wetness/leaf_wetness"));
const PhenologyInsect = __importStar(require("./by-domain/phenology_insect/phenology_insect"));
const PlantStress = __importStar(require("./by-domain/plant_stress/plant_stress"));
const Soil = __importStar(require("./by-domain/soil/soil"));
const SprayConditions = __importStar(require("./by-domain/spray_conditions/spray_conditions"));
const TrapCatchesInsect = __importStar(require("./by-domain/trap_catches_insect/trap_catches_insect"));
const Weather = __importStar(require("./by-domain/weather/weather"));
const WindMachine = __importStar(require("./by-domain/wind_machine/wind_machine"));
exports.AggIntervalHelpers = {
    AlmondBloom: AlmondBloom.aggregationIntervalHelperByValueTypeId,
    AlmondHullSplit: AlmondHullSplit.aggregationIntervalHelperByValueTypeId,
    Alternaria: Alternaria.aggregationIntervalHelperByValueTypeId,
    BeeHours: BeeHours.aggregationIntervalHelperByValueTypeId,
    CherryPowderyMildew: CherryPowderyMildew.aggregationIntervalHelperByValueTypeId,
    Chill: Chill.aggregationIntervalHelperByValueTypeId,
    DegreeDaysCrop: DegreeDaysCrop.aggregationIntervalHelperByValueTypeId,
    DegreeDaysInsect: DegreeDaysInsect.aggregationIntervalHelperByValueTypeId,
    Evapotranspiration: Evapotranspiration.aggregationIntervalHelperByValueTypeId,
    FireBlight: FireBlight.aggregationIntervalHelperByValueTypeId,
    FruitGrowth: FruitGrowth.aggregationIntervalHelperByValueTypeId,
    GrapePowderyMildew: GrapePowderyMildew.aggregationIntervalHelperByValueTypeId,
    Irrigation: Irrigation.aggregationIntervalHelperByValueTypeId,
    LeafWetness: LeafWetness.aggregationIntervalHelperByValueTypeId,
    PhenologyInsect: PhenologyInsect.aggregationIntervalHelperByValueTypeId,
    PlantStress: PlantStress.aggregationIntervalHelperByValueTypeId,
    Soil: Soil.aggregationIntervalHelperByValueTypeId,
    SprayConditions: SprayConditions.aggregationIntervalHelperByValueTypeId,
    TrapCatchesInsect: TrapCatchesInsect.aggregationIntervalHelperByValueTypeId,
    Weather: Weather.aggregationIntervalHelperByValueTypeId,
    WindMachine: WindMachine.aggregationIntervalHelperByValueTypeId,
};
//# sourceMappingURL=generatedTypes.js.map